import { createSlice } from "@reduxjs/toolkit";
import { updateOrderItemPrice } from "../../reducer/updateOrderItemPrice/updateOrderItemPriceReducer";

const updateOrderItemPriceSlice = createSlice({
  name: "updateOrderItemPrice",
  initialState: { isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateOrderItemPrice.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateOrderItemPrice.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateOrderItemPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default updateOrderItemPriceSlice.reducer;
